export const HEADER = ['', 'Город', 'Улица', 'Время простоя', 'Наблюдатель']
